//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavBlog(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14 4V20H22V4H14ZM20 18H16V6H20V18Z" fill="currentColor" /><path d="M2 12H12V4H2V12ZM4 6H10V10H4V6Z" fill="currentColor" /><path d="M12 14H2V16H12V14Z" fill="currentColor" /><path d="M12 18H2V20H12V18Z" fill="currentColor" /></svg>;
}
export default IconNavBlog;